import React from 'react';
import './Loader.css';

interface LoaderProps {
  isLoading?: boolean;
  size?: 'small' | 'medium' | 'large';
  color?: string;
  blurAmount?: number;
}

const Loader: React.FC<LoaderProps> = ({
  isLoading = true,
  size = 'medium',
  color = '#0066ff',
  blurAmount = 4
}) => {
  if (!isLoading) return null;

  return (
    <div 
      className="loader-container"
      style={{ 
        backdropFilter: `blur(${blurAmount}px)`,
        WebkitBackdropFilter: `blur(${blurAmount}px)`
      }}
    >
      <div 
        className={`loader ${size}`}
        style={{ borderTopColor: color }}
      />
    </div>
  );
};

export default Loader; 